import {apiUserAccessLink} from "@/request/API"

export default function accessLink(link){
  if(link.search("tb.53kf.com") != -1 && this.$store.state.loginStatus){
      apiUserAccessLink({
        link: `${link}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`
      })
    }
}
